import {
  CampaignPackage,
  CampaignPackageType,
} from "core/orderAd/orderAd.entity";
import { strings } from "intl/fa";

export interface PackageInfo {
  packageType: CampaignPackageType;
  name: string;
  desc: string;
  cuncurrent_campaigns: number;
  view_count: number;
  daily_view: number;
  credit_expire_period: number;
  price_rial: number;
  discounted_percent: number;
  sponsored_count?: number;
}

export const packagesText = {
  [CampaignPackageType.NOPACKAGE]:
    strings.packages.modal.package_item.no_package,
  [CampaignPackageType.BASIC]: strings.packages.modal.package_item.basic_desc,
  [CampaignPackageType.ADVANCED]:
    strings.packages.modal.package_item.advanced_desc,
  [CampaignPackageType.BUSINESS]:
    strings.packages.modal.package_item.business_desc,
  [CampaignPackageType.CUSTOM]: strings.packages.modal.package_item.custom_desc,
};

export const packagesTitle = {
  [CampaignPackageType.NOPACKAGE]:
    strings.packages.modal.package_item.no_package,
  [CampaignPackageType.BASIC]: strings.packages.modal.package_item.basic,
  [CampaignPackageType.ADVANCED]: strings.packages.modal.package_item.advanced,
  [CampaignPackageType.BUSINESS]: strings.packages.modal.package_item.business,
  [CampaignPackageType.CUSTOM]: strings.packages.modal.package_item.custom,
};

export type PackagesNames = "basic" | "advanced" | "business";

const packageNames = {
  [CampaignPackageType.NOPACKAGE]: "none",
  [CampaignPackageType.BASIC]: "basic",
  [CampaignPackageType.ADVANCED]: "advanced",
  [CampaignPackageType.BUSINESS]: "business",
  [CampaignPackageType.CUSTOM]: "custom",
};

export const createPackageInfoObject = (
  campaign: CampaignPackage,
  type: CampaignPackageType
): PackageInfo => ({
  packageType: type,
  name: packageNames[type],
  desc: packagesText[type],
  cuncurrent_campaigns: campaign.allowed_concurrent_campaigns,
  view_count: campaign.dialog_view,
  daily_view: campaign.daily_view_capacity,
  credit_expire_period: campaign.credit_expire_days,
  price_rial: campaign.base_credit,
  discounted_percent: 0,
  sponsored_count: campaign.sponsored_view,
});
